"use client";

import { useEffect, useState } from "react";

export default function Testimonials() {

    // Testimonials data MUST come before useEffect
    const testimonials = [
        {
            name: "Ahmed Khan",
            country: "Pakistan",
            review:
                "Amazing stay! The hotel was spotless and the service was exceptional. Will definitely book again.",
            avatar: "https://i.pravatar.cc/100?img=12",
        },
        {
            name: "Sarah Johnson",
            country: "United Kingdom",
            review:
                "Found the best deal on Dubai Hotel Rates. Easy booking process and great customer support.",
            avatar: "https://i.pravatar.cc/100?img=47",
        },
        {
            name: "David Lee",
            country: "Australia",
            review:
                "Highly recommend! The location was perfect and the view was breathtaking.",
            avatar: "https://i.pravatar.cc/100?img=11",
        },
        {
            name: "Maria Wilson",
            country: "United States",
            review:
                "Everything was smooth from booking to check-in. Excellent hotel options and great prices.",
            avatar: "https://i.pravatar.cc/100?img=32",
        },
        {
            name: "Omar Hassan",
            country: "United Arab Emirates",
            review:
                "Very easy to compare hotels and find the right option. The whole experience was excellent.",
            avatar: "https://i.pravatar.cc/100?img=53",
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    // AUTO SLIDER
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex(
                (prev) => (prev + 1) % testimonials.length
            );
        }, 4000);

        return () => clearInterval(interval);
    }, [testimonials.length]);

    // NEXT
    const nextSlide = () => {
        setActiveIndex(
            (prev) => (prev + 1) % testimonials.length
        );
    };

    // PREVIOUS
    const prevSlide = () => {
        setActiveIndex(
            (prev) =>
                (prev - 1 + testimonials.length) %
                testimonials.length
        );
    };

    const visibleTestimonials = [
        testimonials[activeIndex % testimonials.length],
        testimonials[(activeIndex + 1) % testimonials.length],
        testimonials[(activeIndex + 2) % testimonials.length],
    ];

    // YOUR JSX STARTS HERE
    return (

        <section className="relative overflow-hidden bg-[#F7F5EF] py-16 sm:py-20 lg:py-24">

            {/* Decorative Background */}
            <div className="absolute -left-32 top-20 h-72 w-72 rounded-full bg-[#D5A33C]/10 blur-3xl" />
            <div className="absolute -right-32 bottom-0 h-80 w-80 rounded-full bg-[#0B5552]/10 blur-3xl" />

            <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 xl:px-16">

                {/* HEADER */}
                <div className="mb-12 flex flex-col items-center text-center">

                    <div className="mb-4 flex items-center gap-3">
                        <span className="h-px w-8 bg-[#B78932]" />

                        <span className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#0B5552]">
                            Guest Experiences
                        </span>

                        <span className="h-px w-8 bg-[#B78932]" />
                    </div>

                    <h2 className="max-w-3xl font-serif text-3xl font-medium leading-tight text-[#173F3E] sm:text-4xl lg:text-5xl">
                        Loved by Travelers
                    </h2>

                    <p className="mt-4 max-w-2xl text-sm leading-7 text-[#5E625F] sm:text-base">
                        Hear from travelers who discovered their ideal Dubai
                        stay through Dubai Hotel Rates. Real experiences,
                        honest feedback and confident hotel choices.
                    </p>
                </div>


                {/* TESTIMONIAL SLIDER */}
                <div className="relative">

                    {/* LEFT ARROW */}
                    <button
                        type="button"
                        onClick={prevSlide}
                        aria-label="Previous testimonial"
                        className="absolute left-0 top-1/2 z-20 flex h-11 w-11 -translate-y-1/2 -translate-x-1/2 items-center justify-center border border-[#DED8CC] bg-[#FBFAF6] text-[#173F3E] shadow-sm transition-all duration-300 hover:border-[#B78932] hover:bg-[#173F3E] hover:text-white sm:h-12 sm:w-12"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="h-5 w-5"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M15.75 19.5 8.25 12l7.5-7.5"
                            />
                        </svg>
                    </button>


                    {/* CARDS */}
                    <div className="grid grid-cols-1 gap-5 md:grid-cols-3">

                        {visibleTestimonials.map((testimonial, index) => (
                            <div
                                key={`${testimonial.name}-${activeIndex}-${index}`}
                                className="group relative flex min-h-[310px] flex-col border border-[#DED8CC] bg-[#FBFAF6] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#B78932] hover:shadow-[0_12px_35px_rgba(23,63,62,0.08)] sm:p-7 lg:p-8"
                            >

                                {/* Gold Top Line */}
                                <div className="absolute left-0 right-0 top-0 h-[2px] bg-[#B78932] opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

                                {/* Quote */}
                                <div className="mb-5 flex items-start justify-between">
                                    <span className="font-serif text-6xl leading-none text-[#D5A33C]/40">
                                        “
                                    </span>

                                    <div className="flex gap-1 pt-2">
                                        {[1, 2, 3, 4, 5].map((star) => (
                                            <svg
                                                key={star}
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                className="h-4 w-4 text-[#B78932]"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.027l-4.627 3.153c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.006Z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        ))}
                                    </div>
                                </div>


                                {/* REVIEW */}
                                <p className="flex-1 text-[15px] leading-7 text-[#4F5552]">
                                    {testimonial.review}
                                </p>


                                {/* DIVIDER */}
                                <div className="my-6 h-px bg-[#E7DED0]" />


                                {/* GUEST */}
                                <div className="flex items-center gap-4">

                                    <img
                                        src={testimonial.avatar}
                                        alt={testimonial.name}
                                        className="h-12 w-12 rounded-full object-cover ring-2 ring-[#F3EBDD]"
                                    />

                                    <div>
                                        <h3 className="font-serif text-lg font-medium text-[#173F3E]">
                                            {testimonial.name}
                                        </h3>

                                        <div className="mt-1 flex items-center gap-2">
                                            <span className="text-xs text-[#777B77]">
                                                {testimonial.country}
                                            </span>

                                            <span className="h-1 w-1 rounded-full bg-[#B78932]" />

                                            <span className="text-[10px] font-semibold uppercase tracking-wider text-[#0B5552]">
                                                Verified Guest
                                            </span>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        ))}

                    </div>


                    {/* RIGHT ARROW */}
                    <button
                        type="button"
                        onClick={nextSlide}
                        aria-label="Next testimonial"
                        className="absolute right-0 top-1/2 z-20 flex h-11 w-11 -translate-y-1/2 translate-x-1/2 items-center justify-center border border-[#DED8CC] bg-[#FBFAF6] text-[#173F3E] shadow-sm transition-all duration-300 hover:border-[#B78932] hover:bg-[#173F3E] hover:text-white sm:h-12 sm:w-12"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="h-5 w-5"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="m8.25 4.5 7.5 7.5-7.5 7.5"
                            />
                        </svg>
                    </button>

                </div>


                {/* DOTS */}
                <div className="mt-9 flex justify-center gap-2">
                    {testimonials.map((testimonial, index) => (
                        <button
                            key={testimonial.name}
                            type="button"
                            aria-label={`Show testimonial ${index + 1}`}
                            onClick={() => setActiveIndex(index)}
                            className={`h-1.5 transition-all duration-300 ${activeIndex === index
                                ? "w-8 bg-[#B78932]"
                                : "w-2 bg-[#C9C4B9] hover:bg-[#173F3E]"
                                }`}
                        />
                    ))}
                </div>

            </div>
        </section>
    );
}